import aboutus from '../../assets/abotus.jpeg'
import circle1 from '../../assets/circle.png'
import circle2 from '../../assets/circle.png'

const about =()=>{
   return(
    <>
        <div className="conatiner-fluid" style={{backgroundColor:'white'}}>
            <div className="container aboutContent" style={{padding:'50px'}}>
                <div class="row align-items-center">
                    {/* Image first on mobile, second on desktop */}
                    <div class="col-md-6 order-1 order-md-2">
                        <img src={aboutus} alt="aboutus" className='img-fluid rounded'/>

                    </div>
                    {/* Text second on mobile, first on desktop */}
                    <div class="col-md-6 order-2 order-md-1">
                        <p style={{lineHeight:'1.5', }}>
                            <p style={{color:'#060606ff', fontWeight:'500'}}>AKCODA</p>
                            <h2 style={{color:'#3e13c0ff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>Why Choose Us ?</h2>
                            At AKCODA, we are a full-service digital solutions provider dedicated to turning ideas into impactful experiences. Specializing in website development, eCommerce solutions,Android applications, iOS applications, and custom software development, we empower businesses with technology that drives growth.
                            <br/><br/>
                            With a passion for innovation and a commitment to quality, our team of skilled developers and designers work closely with clients to deliver tailor-made solutions that meet their specific needs. Whether you're a startup looking to establish a digital presence or an established brand aiming to scale, we bring the expertise and creativity to make it happen.
                            <br/><br/>
                            <h5 style={{fontWeight:'500'}}>Our Services Include</h5>
                            1. Website Development: Responsive, fast, and SEO-friendly websites.<br/>
                            2. eCommerce Solutions: Secure, scalable online stores to boost your sales.<br/>
                            3. Android & iOS App Development: Intuitive mobile apps for maximum user engagement.<br/>
                            4. Custom Applications: Fully customized software built to streamline your operations.<br/>
                                <br/>
                            <span style={{fontWeight:'500'}}>We don’t just build software — we build partnerships. Let’s grow together.</span>
                        </p>
                    </div>
                </div>

                
            </div>
        </div>
    </>
   )
}
export default about